import { render } from "./form-input.vue?vue&type=template&id=71a81ac2&scoped=true"
import script from "./form-input.vue?vue&type=script&lang=js"
export * from "./form-input.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-71a81ac2"

export default script